<script setup lang="ts">
import { useTheme } from '@/stores/theme';

const theme = useTheme();
</script>
<template>
  <div class="owpi-spa-nbas">
    <wb-skeleton :theme="theme.wb" />
    <wb-skeleton :theme="theme.wb" />
    <wb-skeleton :theme="theme.wb" />
  </div>
</template>
<style lang="scss" src="./SectionNba.scss" />
